<div class="container">
    <iframe *ngIf="siteId == '3000' " class="responsive-iframe" src="https://minidashboard-spm-ppe-cloud.azurewebsites.net"></iframe>
</div>
